import { Component } from "@/types/types"
import { TextButton } from "@/ui/atoms/controls/TextButton"
import { cx } from "@/utils/cx"
import { tx } from "@/utils/tx"
import { useRef } from "react"

export const COMPONENT_NAME = "cookieButton"

export const presets = {}

export interface Props extends Component {}

export function CookieButton({ className, testId = COMPONENT_NAME }: Props) {
  const cookieButtonRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <button
        className={cx(`ot-sdk-show-settings`, className)}
        key="ot-sdk-btn"
        id="ot-sdk-btn"
        ref={cookieButtonRef}
        tabIndex={-1}
        style={{ visibility: "hidden", position: "absolute", top: "-9999px" }}
        aria-hidden
      ></button>

      <TextButton
        onClick={() => cookieButtonRef.current?.click()}
        className="text-left !font-normal"
        testId={tx(testId)}
      >
        Cookie settings
      </TextButton>
    </>
  )
}
